import React from 'react';
import './css/Footer.css'; // Importez le fichier CSS pour le Footer

const Footer = () => {
  return (
    <div className="footer">
      <div className="social-icons">
        <a href="mailto:valentin.leverrier@gmail.com">
          <img src="/image/mail.webp" alt="Mail" loading="lazy" />
        </a>
        <a href="tel:+33610381216">
          <img src="/image/phone.webp" alt="Téléphone" loading="lazy" />
        </a>
        <a
          href="https://www.instagram.com/fousound/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/image/insta.webp" alt="Instagram" loading="lazy" />
        </a>
      </div>
    </div>
  );
};

export default Footer;